import { observer } from 'mobx-react-lite'
import { useNavigate } from 'react-router-dom'

import { Button } from 'components'
import { useValueContext } from 'contexts'

import './styles.scss'

interface FooterProps {
  onDelete: () => void
}
export const Footer = observer(({ onDelete }: FooterProps) => {
  const { eventStore } = useValueContext()
  const { isNew, isValid, loading, save } = eventStore
  const navigate = useNavigate()

  const onCreateEvent = async () => {
    const result = await save()

    if (result) {
      navigate('/home')
    }
  }

  return (
    <div className="event-footer">
      {!isNew && (
        <Button className="delete-button" onClick={onDelete}>
          Удалить запись
        </Button>
      )}
      <Button width="100%" disabled={!isValid || loading} onClick={onCreateEvent}>
        Сохранить изменения
      </Button>
    </div>
  )
})
